import { useState, useEffect, useMemo, useRef } from "react";
import "./SwellWidget.css";

// ─── Constants ──────────────────────────────────────────────────────
const SB_LAT = 34.42, SB_LNG = -119.69, NOAA_STN = "9411340";
const G = 9.81, FT_M = 0.3048, M_FT = 3.281;

// ─── Spot Definitions ───────────────────────────────────────────────
const SPOTS = [
  { name: "Rincon",       swOpt:[250,280], swOk:[230,310], min:3,   tide:"mid",      faceRatio:1.3, windFactor:1.00, tideOpt:[-0.5,3.0], tideWork:[-2.0,5.5], shoreNormal:195, slope:0.04, shelter:1.0, transferMap:{190:0.20,220:0.40,250:0.60,270:0.75,290:0.85,310:0.80} },
  { name: "Sandspit",     swOpt:[240,260], swOk:[220,280], min:2,   tide:"incoming", faceRatio:1.0, windFactor:0.78, tideOpt:[-0.5,2.5], tideWork:[-1.5,4.5], shoreNormal:180, slope:0.06, shelter:0.7, transferMap:{190:0.10,220:0.25,250:0.48,270:0.42,290:0.18,310:0.08} },
  { name: "Leadbetter",   swOpt:[250,270], swOk:[230,280], min:1.5, tide:"mid",      faceRatio:0.9, windFactor:0.72, tideOpt:[0.0,3.0],  tideWork:[-1.0,5.0], shoreNormal:180, slope:0.02, shelter:0.3, transferMap:{190:0.05,220:0.10,250:0.18,270:0.22,290:0.08,310:0.04} },
  { name: "Campus Point", swOpt:[260,290], swOk:[240,310], min:4,   tide:"mid-high", faceRatio:1.2, windFactor:1.00, tideOpt:[-0.5,2.5], tideWork:[-1.5,4.5], shoreNormal:200, slope:0.08, shelter:0.5, transferMap:{190:0.15,220:0.30,250:0.42,270:0.45,290:0.22,310:0.12} },
  { name: "Devereux",     swOpt:[270,305], swOk:[250,325], min:3,   tide:"mid",      faceRatio:1.2, windFactor:0.88, tideOpt:[0.0,3.5],  tideWork:[-1.0,5.0], shoreNormal:195, slope:0.06, shelter:0.55, transferMap:{190:0.18,220:0.35,250:0.45,270:0.55,290:0.42,310:0.30} },
  { name: "El Capitán",   swOpt:[270,310], swOk:[250,330], min:3,   tide:"mid",      faceRatio:1.3, windFactor:1.06, tideOpt:[0.0,3.5],  tideWork:[-1.5,5.5], shoreNormal:200, slope:0.05, shelter:0.75, transferMap:{190:0.12,220:0.30,250:0.55,270:0.72,290:0.65,310:0.55} },
  { name: "Refugio",      swOpt:[265,305], swOk:[245,325], min:2,   tide:"mid",      faceRatio:1.0, windFactor:0.92, tideOpt:[0.0,3.5],  tideWork:[-1.0,5.5], shoreNormal:195, slope:0.03, shelter:0.65, transferMap:{190:0.10,220:0.28,250:0.50,270:0.65,290:0.55,310:0.45} },
  { name: "Naples",       swOpt:[270,310], swOk:[250,330], min:3,   tide:"mid-low",  faceRatio:1.2, windFactor:1.00, tideOpt:[-0.5,2.5], tideWork:[-2.0,4.5], shoreNormal:200, slope:0.07, shelter:0.70, transferMap:{190:0.12,220:0.30,250:0.52,270:0.68,290:0.58,310:0.48} },
  { name: "Hammonds",     swOpt:[185,225], swOk:[170,250], min:2,   tide:"mid",      faceRatio:1.1, windFactor:0.83, tideOpt:[0.0,3.0],  tideWork:[-1.0,5.0], shoreNormal:190, slope:0.06, shelter:0.55, transferMap:{190:0.45,220:0.50,250:0.35,270:0.25,290:0.12,310:0.06} },
  { name: "Mesa Lane",    swOpt:[230,270], swOk:[210,290], min:2,   tide:"mid-low",  faceRatio:1.2, windFactor:0.90, tideOpt:[-0.5,2.5], tideWork:[-1.5,4.5], shoreNormal:185, slope:0.07, shelter:0.40, transferMap:{190:0.08,220:0.15,250:0.25,270:0.28,290:0.10,310:0.05} },
  { name: "Sands",        swOpt:[235,275], swOk:[215,295], min:2,   tide:"mid",      faceRatio:1.0, windFactor:0.80, tideOpt:[0.0,3.0],  tideWork:[-1.0,5.0], shoreNormal:180, slope:0.03, shelter:0.35, transferMap:{190:0.07,220:0.14,250:0.22,270:0.25,290:0.09,310:0.04} },
  { name: "Hobson's",     swOpt:[255,295], swOk:[230,320], min:2,   tide:"mid",      faceRatio:1.3, windFactor:0.98, tideOpt:[-0.5,3.5], tideWork:[-2.0,5.5], shoreNormal:195, slope:0.04, shelter:0.90, transferMap:{190:0.20,220:0.38,250:0.52,270:0.68,290:0.75,310:0.70} },
  { name: "Mondo's",      swOpt:[225,275], swOk:[185,315], min:2,   tide:"mid",      faceRatio:1.2, windFactor:0.90, tideOpt:[0.0,3.0],  tideWork:[-1.5,5.0], shoreNormal:200, slope:0.03, shelter:0.80, transferMap:{190:0.25,220:0.45,250:0.60,270:0.72,290:0.78,310:0.70} },
  { name: "C Street",     swOpt:[255,295], swOk:[220,330], min:2,   tide:"mid",      faceRatio:1.35,windFactor:0.95, tideOpt:[0.0,3.5],  tideWork:[-1.5,5.5], shoreNormal:200, slope:0.03, shelter:0.80, transferMap:{190:0.20,220:0.40,250:0.55,270:0.72,290:0.80,310:0.72} },
  { name: "Little Rincon",swOpt:[250,290], swOk:[230,310], min:2,   tide:"mid",      faceRatio:1.2, windFactor:0.95, tideOpt:[0.0,3.5],  tideWork:[-1.5,5.5], shoreNormal:195, slope:0.04, shelter:0.92, transferMap:{190:0.25,220:0.42,250:0.55,270:0.70,290:0.78,310:0.72} },
  { name: "Pitas Point",  swOpt:[255,295], swOk:[230,320], min:2,   tide:"mid-low",  faceRatio:1.3, windFactor:0.95, tideOpt:[-0.5,3.0], tideWork:[-2.0,5.0], shoreNormal:200, slope:0.05, shelter:0.85, transferMap:{190:0.22,220:0.42,250:0.58,270:0.72,290:0.82,310:0.75} },
  { name: "North Point",  swOpt:[250,280], swOk:[225,305], min:2.5, tide:"mid-high", faceRatio:1.2, windFactor:0.88, tideOpt:[0.5,3.5],  tideWork:[-1.0,5.0], shoreNormal:190, slope:0.06, shelter:0.42, transferMap:{190:0.22,220:0.35,250:0.50,270:0.55,290:0.38,310:0.25} },
];

// ─── Physics Helpers ────────────────────────────────────────────────
function angleDiff(a, b) { const d = ((b - a + 360) % 360); return d > 180 ? 360 - d : d; }
function inWindow(dir, lo, hi) { return lo <= hi ? (dir >= lo && dir <= hi) : (dir >= lo || dir <= hi); }

function komarBreaker(h0_ft, period) {
  if (h0_ft <= 0 || period <= 0) return 0;
  const h0 = h0_ft * FT_M;
  return 0.39 * Math.pow(G, 0.2) * Math.pow(period * h0 * h0, 0.4) * M_FT;
}

const TRANSFER_DIRS = [190, 220, 250, 270, 290, 310];
function interpolateTransfer(dir, tmap) {
  if (!tmap) return 0.5;
  dir = ((dir % 360) + 360) % 360;
  if (dir < 170 || dir > 330) return 0.02;
  if (dir < 190) return tmap[190] * ((dir - 170) / 20) * 0.5;
  if (dir > 310) return tmap[310] * ((330 - dir) / 20) * 0.5;
  for (let i = 0; i < TRANSFER_DIRS.length - 1; i++) {
    if (dir >= TRANSFER_DIRS[i] && dir <= TRANSFER_DIRS[i + 1]) {
      const lo = TRANSFER_DIRS[i], hi = TRANSFER_DIRS[i + 1];
      const t = (dir - lo) / (hi - lo);
      return tmap[lo] * (1 - t) + tmap[hi] * t;
    }
  }
  return tmap[270] || 0.5;
}

function periodWrapBonus(swellDir, swellPer, spot) {
  if (swellDir < 280 || swellDir > 330) return 1.0;
  const wrapSens = Math.max(0, 1.0 - (spot.shelter ?? 1.0));
  if (wrapSens < 0.05 || swellPer <= 12) return 1.0;
  return 1.0 + Math.min((swellPer - 12) / 6, 1.0) * wrapSens * 0.8;
}

function channelTransfer(swellDir, swellPer, spot) {
  return Math.min(interpolateTransfer(swellDir, spot.transferMap) * periodWrapBonus(swellDir, swellPer, spot), 1.0);
}

function swellDirFactor(dir, spot) {
  if (inWindow(dir, spot.swOpt[0], spot.swOpt[1])) return 1.0;
  if (inWindow(dir, spot.swOk[0], spot.swOk[1])) {
    const optMid = ((spot.swOpt[0] + spot.swOpt[1]) / 2) % 360;
    const optHalf = angleDiff(spot.swOpt[0], spot.swOpt[1]) / 2;
    const okHalf = angleDiff(spot.swOk[0], spot.swOk[1]) / 2;
    const diff = angleDiff(dir, optMid);
    const t = Math.max(0, (diff - optHalf) / Math.max(okHalf - optHalf, 1));
    return 0.55 + 0.45 * Math.cos(t * Math.PI / 2);
  }
  const diff = angleDiff(dir, ((spot.swOpt[0] + spot.swOpt[1]) / 2) % 360);
  return diff < 70 ? 0.25 : diff < 90 ? 0.12 : 0.08;
}

function periodFactor(p) {
  if (p >= 18) return 1.25; if (p >= 14) return 1.10; if (p >= 11) return 1.0;
  if (p >= 9)  return 0.55; if (p >= 8)  return 0.38; if (p >= 7)  return 0.20;
  return 0.10;
}

function periodSizeMult(p) {
  if (p >= 14) return 1.00; if (p >= 11) return 0.85; if (p >= 9) return 0.55;
  if (p >= 8)  return 0.42; if (p >= 7)  return 0.28; return 0.15;
}

function windFactor(ws, wd, spot) {
  if (ws < 3) return 1.0;
  const relAngle = angleDiff(wd, spot?.shoreNormal ?? 180);
  const effectiveWs = ws * (spot?.windFactor ?? 1.0);
  if (effectiveWs < 3) return 1.0;
  if (relAngle <= 60) {
    if (effectiveWs <= 8) return 1.0;
    if (effectiveWs <= 15) return 1.0 - (effectiveWs - 8) * 0.03;
    if (effectiveWs <= 20) return 0.79 - (effectiveWs - 15) * 0.04;
    return Math.max(0.50, 0.59 - (effectiveWs - 20) * 0.03);
  } else if (relAngle <= 100) {
    if (effectiveWs <= 5) return 0.90;
    if (effectiveWs <= 10) return 0.90 - (effectiveWs - 5) * 0.06;
    if (effectiveWs <= 15) return 0.60 - (effectiveWs - 10) * 0.06;
    return Math.max(0.10, 0.30 - (effectiveWs - 15) * 0.04);
  } else {
    if (effectiveWs <= 5) return 0.82;
    if (effectiveWs <= 10) return 0.82 - (effectiveWs - 5) * 0.08;
    if (effectiveWs <= 15) return 0.42 - (effectiveWs - 10) * 0.06;
    return Math.max(0.05, 0.12 - (effectiveWs - 15) * 0.02);
  }
}

function tideFactor(h, rate, spot) {
  const optLo = spot.tideOpt?.[0] ?? -0.5, optHi = spot.tideOpt?.[1] ?? 3.0;
  const workLo = spot.tideWork?.[0] ?? -2.0, workHi = spot.tideWork?.[1] ?? 5.5;
  let hs = h >= optLo && h <= optHi ? 1.0
    : h < optLo ? (h <= workLo ? 0 : (h - workLo) / (optLo - workLo))
    : (h >= workHi ? 0 : (workHi - h) / (workHi - optHi));
  if (spot.tide === "incoming") {
    hs = Math.max(0, Math.min(1, hs + (rate > 0 ? Math.min(0.15, rate * 0.10) : Math.max(-0.10, rate * 0.06))));
  } else {
    hs = Math.max(0, Math.min(1, hs + (rate > 0 ? Math.min(0.05, rate * 0.04) : Math.max(-0.03, rate * 0.02))));
  }
  return 0.3 + hs * 0.7;
}

function calcScore(spot, d) {
  if (!d || !d.swellHt || d.swellHt < 0.3) return 0;
  const spotHs = d.swellHt * channelTransfer(d.swellDir || 0, d.swellPer || 10, spot);
  if (spotHs < spot.min * 0.4) return 0;
  const breakerHt = komarBreaker(spotHs, d.swellPer || 10);
  const faceHt = breakerHt * (spot.faceRatio || 1.0);
  const htRatio = Math.min(faceHt / Math.max(spot.min, 1), 3.0);
  const heightScore = Math.pow(htRatio, 0.65) * 2.5;
  const raw = heightScore * swellDirFactor(d.swellDir || 0, spot)
    * windFactor(d.windSpeed || 0, d.windDir || 0, spot)
    * periodFactor(d.swellPer || 10)
    * tideFactor(d.tideH ?? 2.5, d.tideRate ?? 0, spot);
  return Math.min(Math.round(raw * 10) / 10, 10);
}

function estimateSurfHeight(spot, d) {
  if (!d || !d.swellHt || d.swellHt < 0.3) return [0, 0];
  const spotHs = d.swellHt * channelTransfer(d.swellDir || 0, d.swellPer || 10, spot);
  if (spotHs < spot.min * 0.4) return [0, 0];
  const per = d.swellPer || 10;
  const faceHt = komarBreaker(spotHs, per) * (spot.faceRatio || 1.0) * periodSizeMult(per);
  const round5 = v => Math.round(v * 2) / 2;
  return [Math.max(0, round5(faceHt * 0.7)), round5(faceHt * 1.3)];
}

// ─── Display Helpers ────────────────────────────────────────────────
function scoreLabel(s) {
  if (s >= 8) return "Epic"; if (s >= 6.5) return "Firing"; if (s >= 5) return "Fun";
  if (s >= 3.5) return "Decent"; if (s >= 2) return "Surfable"; if (s > 0) return "Poor";
  return "Flat";
}
function scoreToStars(score) { return Math.round((score / 2) * 2) / 2; }
function starColor(score) {
  const s = score || 0;
  if (s >= 7) return "#2ecc71"; if (s >= 5) return "#5ebc60"; if (s >= 3.5) return "#f0a030";
  if (s >= 2) return "#e07038"; return "#e05040";
}
function surfHeightColor(ft) {
  if (ft >= 5) return "#2ecc71"; if (ft >= 3.5) return "#5ebc60";
  if (ft >= 2.5) return "#f0a030"; if (ft >= 1.5) return "#e07038"; return "#e05040";
}
function windSpeedColor(kts) {
  if (kts <= 5) return "#2ecc71"; if (kts <= 8) return "#5ebc60";
  if (kts <= 12) return "#f0a030"; if (kts <= 18) return "#e07038"; return "#e05040";
}
function degToCompass(d) {
  if (d == null || isNaN(d)) return "--";
  return ["N","NNE","NE","ENE","E","ESE","SE","SSE","S","SSW","SW","WSW","W","WNW","NW","NNW"][Math.round(d / 22.5) % 16];
}
function fmtHr(h) { return h === 0 ? "12am" : h === 12 ? "12pm" : h < 12 ? h + "am" : (h - 12) + "pm"; }
function fmtDecHr(h) {
  const hh = Math.floor(h), mm = Math.round((h - hh) * 60);
  const ap = hh < 12 ? "am" : "pm", hd = hh % 12 || 12;
  return `${hd}:${String(mm).padStart(2, "0")}${ap}`;
}
function sbSeasonalWaterTemp() {
  const m = new Date().getMonth(); // 0-11
  return [59,58,59,60,62,64,66,67,67,64,62,60][m];
}
function wetsuitRec(tempF) {
  if (tempF < 58) return "4/3mm+"; if (tempF < 61) return "4/3mm";
  if (tempF < 64) return "3/2mm"; if (tempF < 67) return "springsuit";
  return "trunks";
}
function boardRec(scores) {
  if (!scores || scores.length === 0) return null;
  const topScore = scores[0]?.score || 0;
  const topHi = scores[0]?.heights?.[1] || 0;
  if (topHi < 3 || topScore < 2) return "longboard";
  if (topHi < 4.5) return "mid-length";
  return null; // shortboard conditions — no rec needed
}
function safeNum(v, fb = 0) { const n = parseFloat(v); return isNaN(n) ? fb : n; }
function tagColor(q) { if (q === "good") return "#2ecc71"; if (q === "ok") return "#f0a030"; return "#e05040"; }
function swellQuality(swellDir, spot) {
  if (inWindow(swellDir, spot.swOpt[0], spot.swOpt[1])) return "good";
  if (inWindow(swellDir, spot.swOk[0], spot.swOk[1])) return "ok";
  return "bad";
}
function tideFavorable(spot, tideH, tideRate) {
  const optLo = spot.tideOpt?.[0] ?? -0.5, optHi = spot.tideOpt?.[1] ?? 3.0;
  const workLo = spot.tideWork?.[0] ?? -2.0, workHi = spot.tideWork?.[1] ?? 5.5;
  if (tideH >= optLo && tideH <= optHi) return "good";
  if (tideH >= workLo && tideH <= workHi) return "ok";
  return "bad";
}
function windQualityStr(windSpeed, windDir, spot) {
  const wf = windFactor(windSpeed, windDir, spot || { shoreNormal: 180, windFactor: 1.0 });
  if (wf >= 0.80) return "good"; if (wf >= 0.45) return "ok"; return "bad";
}
function sineWavePath(W, H, amp, phase, cycles, centerY) {
  const cy = centerY != null ? centerY : H / 2;
  const pts = [];
  for (let x = 0; x <= W; x += 3) {
    const t = (x / W) * cycles * 2 * Math.PI;
    // Amplitude variation: layered harmonics for organic feel
    const ampVar = 1 + 0.35 * Math.sin(t * 0.37 + phase * 1.7) + 0.2 * Math.sin(t * 0.71 + phase * 0.9) + 0.1 * Math.sin(t * 1.53 + phase * 2.3);
    const y = cy + amp * ampVar * Math.sin(phase + t);
    pts.push((x === 0 ? 'M' : 'L') + x + ',' + y.toFixed(1));
  }
  return pts.join(' ');
}
function localDateStr(d) {
  return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
}

// ─── Solar Calculator ────────────────────────────────────────────────
function getSunTimes(dateStr, lat, lon) {
  const d = new Date(dateStr + "T12:00:00");
  const tzOffsetHrs = -d.getTimezoneOffset() / 60;
  const start = new Date(d.getFullYear(), 0, 0);
  const doy = Math.floor((d - start) / 86400000);
  const B = (2 * Math.PI / 365) * (doy - 1);
  const EoT = 229.18 * (0.000075 + 0.001868 * Math.cos(B) - 0.032077 * Math.sin(B) - 0.014615 * Math.cos(2*B) - 0.04089 * Math.sin(2*B));
  const decl = 0.006918 - 0.399912 * Math.cos(B) + 0.070257 * Math.sin(B) - 0.006758 * Math.cos(2*B) + 0.000907 * Math.sin(2*B) - 0.002697 * Math.cos(3*B) + 0.00148 * Math.sin(3*B);
  const latRad = lat * Math.PI / 180;
  const utcNoon = 12 - EoT / 60 - lon / 15;
  const solarNoon = utcNoon + tzOffsetHrs;
  const calc = (zenithDeg) => {
    const cosH = (Math.cos(zenithDeg * Math.PI / 180) - Math.sin(latRad) * Math.sin(decl)) / (Math.cos(latRad) * Math.cos(decl));
    if (cosH < -1 || cosH > 1) return null;
    return Math.acos(cosH) * 180 / Math.PI / 15;
  };
  const h0 = calc(90.833), hc = calc(96);
  if (!h0 || !hc) return null;
  return { dawn: solarNoon - hc, sunrise: solarNoon - h0, sunset: solarNoon + h0, dusk: solarNoon + hc };
}

// ─── Data Fetchers ───────────────────────────────────────────────────
async function fetchMarine(ds) {
  const url = `https://marine-api.open-meteo.com/v1/marine?latitude=${SB_LAT}&longitude=${SB_LNG}&hourly=wave_height,wave_direction,wave_period,swell_wave_height,swell_wave_direction,swell_wave_period,wind_wave_height,wind_wave_direction,wind_wave_period,secondary_swell_wave_height,secondary_swell_wave_direction,secondary_swell_wave_period&start_date=${ds}&end_date=${ds}&timezone=America/Los_Angeles`;
  const r = await fetch(url); if (!r.ok) throw new Error("Marine " + r.status);
  return r.json();
}
async function fetchWeather(ds) {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${SB_LAT}&longitude=${SB_LNG}&hourly=wind_speed_10m,wind_direction_10m,wind_gusts_10m,temperature_2m,weather_code&start_date=${ds}&end_date=${ds}&timezone=America/Los_Angeles&wind_speed_unit=kn`;
  const r = await fetch(url); if (!r.ok) throw new Error("Weather " + r.status);
  return r.json();
}
async function fetchTides(ds) {
  const begin = ds.replace(/-/g, "");
  const parts = ds.split("-");
  const ed = new Date(+parts[0], +parts[1] - 1, +parts[2] + 1);
  const endStr = localDateStr(ed).replace(/-/g, "");
  const url = `https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?begin_date=${begin}&end_date=${endStr}&station=${NOAA_STN}&product=predictions&datum=MLLW&units=english&time_zone=lst_ldt&interval=h&format=json`;
  const r = await fetch(url); if (!r.ok) throw new Error("Tides " + r.status);
  const data = await r.json();
  return Array.isArray(data.predictions) ? data.predictions : [];
}
async function fetchTidesExact(ds) {
  const begin = ds.replace(/-/g, "");
  const parts = ds.split("-");
  const ed = new Date(+parts[0], +parts[1] - 1, +parts[2] + 1);
  const endStr = localDateStr(ed).replace(/-/g, "");
  const url = `https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?begin_date=${begin}&end_date=${endStr}&station=${NOAA_STN}&product=predictions&datum=MLLW&units=english&time_zone=lst_ldt&interval=hilo&format=json`;
  try {
    const r = await fetch(url); if (!r.ok) return [];
    const data = await r.json();
    if (!Array.isArray(data.predictions)) return [];
    return data.predictions.filter(p => (p.t || "").startsWith(ds)).map(p => {
      const [hh, mm] = ((p.t || "").split(" ")[1] || "0:00").split(":").map(Number);
      return { t: hh + mm / 60, v: parseFloat(p.v), hi: p.type.startsWith("H") };
    });
  } catch { return []; }
}
async function fetchBuoy() {
  const urls = ["/api/buoy?station=46053", "https://www.ndbc.noaa.gov/data/realtime2/46053.txt"];
  for (const url of urls) {
    try {
      const r = await fetch(url); if (!r.ok) continue;
      const text = await r.text();
      const lines = text.trim().split("\n");
      if (lines.length < 3) continue;
      const hdr = lines[0].trim().split(/\s+/);
      const vals = lines[2].trim().split(/\s+/);
      const g = (n) => { const i = hdr.indexOf(n); return i >= 0 ? parseFloat(vals[i]) : null; };
      const wv = g("WVHT"), dp = g("DPD"), mw = g("MWD");
      if (wv == null || isNaN(wv) || wv >= 99) continue;
      const wt = g("WTMP");
      return { waveHeight: (wv * M_FT).toFixed(1), peakPeriod: dp != null && dp < 99 ? dp : null, waveDir: mw != null && mw < 999 ? mw : null, waterTemp: wt != null && wt < 99 ? Math.round(wt * 9/5 + 32) : null };
    } catch { /* try next */ }
  }
  return null;
}

function assembleHourlyData(marine, weather, tides) {
  const mh = marine.hourly, wh = weather.hourly;
  const tideMap = {};
  for (const t of tides) {
    try {
      // NOAA returns "YYYY-MM-DD HH:MM" in local time — parse hour directly from string
      const timePart = (t.t || "").split(" ")[1] || "";
      const hour = parseInt(timePart.split(":")[0], 10);
      if (!isNaN(hour)) tideMap[hour] = safeNum(t.v, 2.5);
    } catch { /* skip */ }
  }
  const hours = [];
  for (let i = 0; i < 24; i++) {
    const swH = safeNum(mh.swell_wave_height?.[i]) || safeNum(mh.wave_height?.[i]);
    const swD = safeNum(mh.swell_wave_direction?.[i]) || safeNum(mh.wave_direction?.[i]);
    const swP = safeNum(mh.swell_wave_period?.[i]) || safeNum(mh.wave_period?.[i]);
    const ws = safeNum(wh.wind_speed_10m?.[i]), wd = safeNum(wh.wind_direction_10m?.[i]), wg = safeNum(wh.wind_gusts_10m?.[i]);
    let tH = 2.5;
    if (tideMap[i] != null) tH = tideMap[i];
    else if (tides.length >= 2) {
      for (let j = 0; j < tides.length - 1; j++) {
        const h0 = new Date(tides[j].t).getHours(), h1 = new Date(tides[j+1].t).getHours();
        if (i >= h0 && i <= h1) { tH = safeNum(tides[j].v, 2.5) + (h1 > h0 ? (i-h0)/(h1-h0) : 0) * (safeNum(tides[j+1].v, 2.5) - safeNum(tides[j].v, 2.5)); break; }
      }
    }
    hours.push({ swellHt: swH * M_FT, swellDir: swD, swellPer: swP, windSpeed: ws, windDir: wd, windGust: wg, tideH: tH });
  }
  for (let i = 0; i < 24; i++) {
    const prev = i > 0 ? hours[i-1].tideH : hours[0].tideH, next = i < 23 ? hours[i+1].tideH : hours[23].tideH;
    hours[i].tideRate = (next - prev) / 2;
  }
  return hours;
}

// ─── Mini Sub-components ─────────────────────────────────────────────
function StarRating({ score, size = 13 }) {
  const stars = scoreToStars(score), col = starColor(score);
  const arr = [];
  for (let i = 1; i <= 5; i++) arr.push(i <= stars ? "full" : i - 0.5 <= stars ? "half" : "empty");
  return (
    <span style={{ display: "inline-flex", gap: size * 0.08 }}>
      {arr.map((type, i) => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24" fill="none">
          {type === "full" && <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={col} />}
          {type === "half" && <>
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={col} opacity="0.2" />
            <clipPath id={`sw-h${i}${Math.round(score*10)}`}><rect x="0" y="0" width="12" height="24" /></clipPath>
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={col} clipPath={`url(#sw-h${i}${Math.round(score*10)})`} />
          </>}
          {type === "empty" && <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={col} opacity="0.2" />}
        </svg>
      ))}
    </span>
  );
}

function Compass({ dir, size = 36, color = "#c9a84c", value, maxValue }) {
  if (dir == null || isNaN(dir)) return null;
  const rad = (dir - 90) * Math.PI / 180;
  const cx = size / 2, cy = size / 2, r = size / 2 - 10;
  const t = (value != null && maxValue) ? Math.min(value / maxValue, 1) : 0.5;
  const tipLen = r * (1.1 + t * 0.5);
  const tailLen = r * (0.3 + t * 0.2);
  const hw = r * (0.15 + t * 0.2);
  const tipX = cx - tailLen * Math.cos(rad), tipY = cy - tailLen * Math.sin(rad);
  const bX = cx + tipLen * Math.cos(rad), bY = cy + tipLen * Math.sin(rad);
  const pr = rad + Math.PI / 2;
  const labelR = size <= 36 ? r + 4 : r + 7;
  const labelFs = size <= 36 ? 6 : 8;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} overflow="visible" style={{ overflow: "visible" }}>
      <circle cx={cx} cy={cy} r={r + 3} fill="none" stroke="#1e2e3e" strokeWidth="1" />
      {["N","E","S","W"].map((d, i) => {
        const a = (i * 90 - 90) * Math.PI / 180;
        return <text key={d} x={cx + labelR * Math.cos(a)} y={cy + labelR * Math.sin(a)} fill="#4a6a7a" fontSize={labelFs} textAnchor="middle" dominantBaseline="central" fontFamily="'Josefin Sans', sans-serif">{d}</text>;
      })}
      <polygon points={`${tipX},${tipY} ${bX+Math.cos(pr)*hw},${bY+Math.sin(pr)*hw} ${bX-Math.cos(pr)*hw},${bY-Math.sin(pr)*hw}`} fill={color} opacity="0.85" />
    </svg>
  );
}

function TideChart({ data, nowHour, bestTimes, dateStr, tidesExact }) {
  if (!data || data.length < 2) return null;
  const W = 440, H = 82, TOP = 14, BOT = 14, PAD = 0;
  const chartH = H - TOP - BOT;
  const vals = data.map(d => d.tideH);
  const mx = Math.max(...vals, 5), mn = Math.min(...vals, -0.5), rng = mx - mn || 1;
  const hToX = h => Math.max(PAD, Math.min(W - PAD, PAD + (h / 23) * (W - PAD * 2)));
  const vToY = v => TOP + chartH - ((v - mn) / rng) * chartH;
  const pts = data.map((d, i) => ({ x: hToX(i), y: vToY(d.tideH) }));
  let path = `M ${pts[0].x} ${pts[0].y}`;
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[Math.max(i-1,0)], p1 = pts[i], p2 = pts[i+1], p3 = pts[Math.min(i+2,pts.length-1)];
    path += ` C ${p1.x+(p2.x-p0.x)/6},${p1.y+(p2.y-p0.y)/6} ${p2.x-(p3.x-p1.x)/6},${p2.y-(p3.y-p1.y)/6} ${p2.x},${p2.y}`;
  }
  const area = path + ` L ${W},${pts[pts.length-1].y} L ${W},${TOP+chartH} L 0,${TOP+chartH} L 0,${pts[0].y} Z`;
  const nx = nowHour != null ? hToX(nowHour) : null;
  const sun = dateStr ? getSunTimes(dateStr, SB_LAT, SB_LNG) : null;
  const hilos = tidesExact && tidesExact.length > 0
    ? tidesExact.map(p => ({ x: hToX(p.t), y: vToY(p.v), v: p.v, hi: p.hi, t: p.t }))
    : [];
  const axisHours = [0, 4, 8, 12, 16, 20];
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="xMidYMid meet" style={{ display: "block", flex: 1, minHeight: 0 }}>
      <defs>
        <linearGradient id="sw-tg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1a6b8a" stopOpacity="0.4"/>
          <stop offset="100%" stopColor="#0a2030" stopOpacity="0.05"/>
        </linearGradient>
        {sun && <>
          <linearGradient id="sw-dawnG" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor="#f0a030" stopOpacity="0"/><stop offset="100%" stopColor="#f0a030" stopOpacity="0.18"/></linearGradient>
          <linearGradient id="sw-duskG" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor="#f0601a" stopOpacity="0.18"/><stop offset="100%" stopColor="#f0601a" stopOpacity="0"/></linearGradient>
        </>}
      </defs>
      {/* Dawn/dusk bands + sunrise/sunset markers */}
      {sun && (() => {
        const dawnX=hToX(sun.dawn), riseX=hToX(sun.sunrise), setX=hToX(sun.sunset), duskX=hToX(sun.dusk);
        return <g>
          <rect x={dawnX} y={TOP-4} width={riseX-dawnX} height={chartH+4} fill="url(#sw-dawnG)"/>
          <rect x={setX} y={TOP-4} width={duskX-setX} height={chartH+4} fill="url(#sw-duskG)"/>
          <line x1={riseX} y1={TOP-4} x2={riseX} y2={TOP+chartH} stroke="#f0b040" strokeWidth="1" strokeDasharray="2,3" opacity="0.7"/>
          <text x={riseX} y={TOP-6} fill="#d09030" fontSize="6.5" textAnchor="middle" fontFamily="'Josefin Sans', sans-serif">☀</text>
          <line x1={setX} y1={TOP-4} x2={setX} y2={TOP+chartH} stroke="#e06830" strokeWidth="1" strokeDasharray="2,3" opacity="0.7"/>
          <text x={setX} y={TOP-6} fill="#c05820" fontSize="6.5" textAnchor="middle" fontFamily="'Josefin Sans', sans-serif">☀</text>
        </g>;
      })()}
      <path d={area} fill="url(#sw-tg)" />
      <path d={path} fill="none" stroke="#2aa4c4" strokeWidth="1.5" />
      {/* Tide range labels */}
      {[mn,(mn+mx)/2,mx].map((v,i) => <text key={i} x={6} y={TOP+chartH-((v-mn)/rng)*chartH} fill="#6a8a9a" fontSize="7" textAnchor="start" dominantBaseline="central" fontFamily="'Josefin Sans', sans-serif" opacity="0.6">{v.toFixed(1)}'</text>)}
      {/* Best times highlight */}
      {(bestTimes || []).length >= 2 && (() => {
        const s = [...bestTimes].sort((a,b) => a.hour-b.hour);
        return <rect x={hToX(s[0].hour)} y={TOP} width={hToX(s[1].hour+1)-hToX(s[0].hour)} height={chartH} fill="#2ecc71" opacity="0.08"/>;
      })()}
      {/* Hi/Lo markers with circles + height and time */}
      {hilos.map((p, i) => {
        const anchor = p.x < 50 ? "start" : p.x > W-50 ? "end" : "middle";
        const tx = p.x < 8 ? 8 : p.x > W-8 ? W-8 : p.x;
        return <g key={i}>
          <circle cx={p.x} cy={p.y} r="3" fill={p.hi?"#2aa4c4":"#1a5a6a"}/>
          <text x={tx} y={p.hi ? p.y-8 : p.y+12} fill={p.hi?"#4ac4e4":"#3a8a9a"} fontSize="8" textAnchor={anchor} fontFamily="'Josefin Sans', sans-serif" fontWeight="600">{p.v.toFixed(1)}' {fmtDecHr(p.t)}</text>
        </g>;
      })}
      {/* NOW marker */}
      {nx != null && <g>
        <line x1={nx} y1={TOP-3} x2={nx} y2={TOP+chartH} stroke="#2aa4c4" strokeWidth="1.5" strokeDasharray="3,2" opacity="0.7"/>
        <text x={nx} y={TOP-6} fill="#2aa4c4" fontSize="6" textAnchor="middle" fontFamily="'Josefin Sans', sans-serif">NOW</text>
      </g>}
      {/* Time axis labels */}
      {axisHours.map(h => {
        const tx = hToX(h);
        const anchor = tx < 10 ? "start" : tx > W - 10 ? "end" : "middle";
        const cx = tx < 4 ? 4 : tx > W - 4 ? W - 4 : tx;
        return <text key={h} x={cx} y={H-2} fill="#6a8a9a" fontSize="7" textAnchor={anchor} fontFamily="'Josefin Sans', sans-serif" opacity="0.6">{fmtHr(h)}</text>;
      })}
      {/* First light / last light times */}
      {sun && (() => {
        const dawnX2 = hToX(sun.dawn), duskX2 = hToX(sun.dusk);
        return <g>
          <text x={dawnX2 < 30 ? 4 : dawnX2} y={H-2} fill="#e8a830" fontSize="8" textAnchor={dawnX2 < 30 ? "start" : "middle"} fontFamily="'Josefin Sans', sans-serif" fontWeight="600" opacity="0.8">{fmtDecHr(sun.dawn)}</text>
          <text x={duskX2 > W-30 ? W-4 : duskX2} y={H-2} fill="#d07020" fontSize="8" textAnchor={duskX2 > W-30 ? "end" : "middle"} fontFamily="'Josefin Sans', sans-serif" fontWeight="600" opacity="0.8">{fmtDecHr(sun.dusk)}</text>
        </g>;
      })()}
    </svg>
  );
}

function SwellChart({ data, nowHour, bestTimes }) {
  if (!data) return null;
  const W = 440, H = 65, TOP = 14, BOT = 12;
  const barZoneH = H - TOP - BOT;
  const startHour = 6, endHour = 21, totalBars = (endHour - startHour) * 4;
  const SPAD = 0;
  const step = (W - SPAD * 2) / totalBars;
  const lerp = (a, b, t) => a + (b - a) * t;
  const angLerp = (a, b, t) => { const d = ((b - a + 540) % 360) - 180; return (a + d * t + 360) % 360; };
  const barData = Array.from({ length: totalBars }, (_, i) => {
    const h = startHour + Math.floor(i / 4), frac = (i % 4) / 4;
    const d0 = data[h], d1 = data[h+1] || d0; if (!d0) return null;
    const swH = lerp(d0.swellHt||0, d1?.swellHt??d0.swellHt, frac);
    const swP = lerp(d0.swellPer||10, d1?.swellPer??d0.swellPer, frac);
    const swD = angLerp(d0.swellDir||0, d1?.swellDir??d0.swellDir??0, frac);
    const tH = lerp(d0.tideH||2.5, d1?.tideH??d0.tideH, frac);
    const ws = lerp(d0.windSpeed||0, d1?.windSpeed??d0.windSpeed, frac);
    const wd = angLerp(d0.windDir||0, d1?.windDir??d0.windDir??0, frac);
    const spotHs = swH * 0.75;
    const bh = spotHs >= 0.3 ? komarBreaker(spotHs, swP) : 0;
    const tideDev = Math.abs(tH - 2.5) / 2.5;
    const wq = windFactor(ws, wd, { shoreNormal: 180, windFactor: 1.0 });
    return { ft: bh * periodSizeMult(swP) * (1 - 0.15 * Math.min(tideDev,1)) * (0.65 + wq * 0.35), dir: swD, per: swP };
  });
  for (let i = 1; i < barData.length; i++) {
    if (!barData[i] || !barData[i-1]) continue;
    const diff = barData[i].ft - barData[i-1].ft;
    if (Math.abs(diff) > 0.6) barData[i] = { ...barData[i], ft: barData[i-1].ft + Math.sign(diff) * 0.6 };
  }
  const maxFt = Math.min(Math.max(...barData.map(b => b?.ft||0), 5), 15);
  const nowMin = new Date().getMinutes();
  const nowBarIdx = nowHour != null ? (nowHour - startHour) * 4 + Math.floor(nowMin / 15) : null;
  const nx = (nowBarIdx != null && nowBarIdx >= 0 && nowBarIdx < totalBars) ? SPAD + nowBarIdx * step : null;
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ display: "block" }}>
      {barData.map((bd, i) => {
        if (!bd) return null;
        const h = startHour + Math.floor(i / 4), isHourStart = i % 4 === 0;
        const dist = nowBarIdx != null ? Math.abs(i - nowBarIdx) : Infinity;
        const isNearNow = dist <= 4;
        const nearNowBoost = isNearNow ? 0.55 * Math.pow(1 - dist / 5, 1.5) : 0;
        const barOpacity = nowBarIdx != null ? Math.min(0.95, 0.35 + nearNowBoost) : 0.55;
        const col = surfHeightColor(bd.ft);
        const bx = SPAD + i * step, cx = bx + step / 2;
        const barH = Math.max(2, (bd.ft / maxFt) * barZoneH);
        const barTop = H - BOT - barH;
        return (
          <g key={i}>
            <rect x={bx} y={barTop} width={step} height={barH} fill={col} opacity={barOpacity}/>
            {isHourStart && bd.ft >= 0.5 && barH > 5 && (
              <text x={cx} y={Math.max(barTop-2, TOP+7)} fill={col} fontSize="7" textAnchor="middle" fontFamily="'Josefin Sans', sans-serif" opacity="0.9">{bd.ft.toFixed(1)}</text>
            )}
            {isHourStart && (() => {
              const rad = (bd.dir + 180 - 90) * Math.PI / 180;
              const arrowCY = TOP / 2;
              const s = 2.5 + Math.min(bd.ft / maxFt, 1) * 4;
              const hw = 1 + Math.min(bd.ft / maxFt, 1) * 1.2;
              const pr = rad + Math.PI / 2;
              const tipX = cx + Math.cos(rad)*s, tipY = arrowCY + Math.sin(rad)*s;
              const bX = cx - Math.cos(rad)*s, bY = arrowCY - Math.sin(rad)*s;
              return <g opacity={nowBarIdx!=null?Math.min(0.95,0.4+nearNowBoost):0.6}>
                <polygon points={`${tipX},${tipY} ${bX+Math.cos(pr)*hw},${bY+Math.sin(pr)*hw} ${bX-Math.cos(pr)*hw},${bY-Math.sin(pr)*hw}`} fill={col}/>
              </g>;
            })()}
            {isHourStart && <text x={h===startHour ? bx+1 : cx} y={H-3} fill={isNearNow&&dist<=2?"#7ac8d8":"#3a5565"} fontSize="8" textAnchor={h===startHour ? "start" : "middle"} fontFamily="'Josefin Sans', sans-serif">{h>12?`${h-12}pm`:h===12?"12pm":`${h}am`}</text>}
          </g>
        );
      })}
      {(bestTimes||[]).length >= 2 && (() => {
        const s = [...bestTimes].sort((a,b)=>a.hour-b.hour);
        const bx1 = SPAD+(s[0].hour-startHour)*4*step, bx2 = SPAD+(s[1].hour-startHour+1)*4*step;
        return <g>
          <rect x={bx1} y={TOP} width={bx2-bx1} height={H-TOP-BOT} fill="#2ecc71" opacity="0.08"/>
          <line x1={bx1} y1={TOP} x2={bx1} y2={H-BOT} stroke="#2ecc71" strokeWidth="1" strokeDasharray="3,2" opacity="0.4"/>
          <line x1={bx2} y1={TOP} x2={bx2} y2={H-BOT} stroke="#2ecc71" strokeWidth="1" strokeDasharray="3,2" opacity="0.4"/>
        </g>;
      })()}
      {nx != null && <line x1={nx} y1={TOP} x2={nx} y2={H-BOT} stroke="#2ab4d4" strokeWidth="1" strokeDasharray="3,2" opacity="0.6"/>}
      <text x={SPAD+2} y={TOP+6} fill="#3a5565" fontSize="7" fontFamily="'Josefin Sans', sans-serif">{Math.round(maxFt)}ft</text>
    </svg>
  );
}

function WindChart({ data, nowHour, bestTimes }) {
  if (!data) return null;
  const W = 440, H = 65, TOP = 14, BOT = 12;
  const barZoneH = H - TOP - BOT, startHour = 6, endHour = 21, totalBars = (endHour - startHour) * 4;
  const WPAD = 0;
  const step = (W - WPAD * 2) / totalBars, maxKnots = 20;
  const lerp = (a, b, t) => a + (b - a) * t;
  const angLerp = (a, b, t) => { const d = ((b - a + 540) % 360) - 180; return (a + d * t + 360) % 360; };
  const barData = Array.from({ length: totalBars }, (_, i) => {
    const h = startHour + Math.floor(i / 4), frac = (i % 4) / 4;
    const d0 = data[h], d1 = data[h+1]||d0; if (!d0) return null;
    return { spd: lerp(d0.windSpeed||0, d1?.windSpeed??d0.windSpeed, frac), dir: angLerp(d0.windDir||0, d1?.windDir??d0.windDir??0, frac) };
  });
  const nowMin = new Date().getMinutes();
  const nowBarIdx = nowHour != null ? (nowHour - startHour) * 4 + Math.floor(nowMin / 15) : null;
  const nx = (nowBarIdx != null && nowBarIdx >= 0 && nowBarIdx < totalBars) ? WPAD + nowBarIdx * step : null;
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ display: "block" }}>
      {barData.map((bd, i) => {
        if (!bd) return null;
        const h = startHour + Math.floor(i / 4), isHourStart = i % 4 === 0;
        const dist = nowBarIdx != null ? Math.abs(i - nowBarIdx) : Infinity;
        const isNearNow = dist <= 4;
        const nearNowBoost = isNearNow ? 0.55 * Math.pow(1 - dist / 5, 1.5) : 0;
        const barOpacity = nowBarIdx != null ? Math.min(0.95, 0.35 + nearNowBoost) : 0.55;
        const col = windSpeedColor(bd.spd);
        const barH = Math.max(2, (Math.min(bd.spd, maxKnots) / maxKnots) * barZoneH);
        const bx = WPAD + i * step, cx = bx + step / 2;
        const barTop = H - BOT - barH;
        return (
          <g key={i}>
            <rect x={bx} y={barTop} width={step-0.8} height={barH} fill={col} opacity={barOpacity} rx="0.5"/>
            {isHourStart && bd.spd >= 2 && barH > 5 && (
              <text x={cx} y={Math.max(barTop-2, TOP+7)} fill={col} fontSize="7" textAnchor="middle" fontFamily="'Josefin Sans', sans-serif" opacity="0.9">{Math.round(bd.spd)}</text>
            )}
            {isHourStart && bd.spd > 0 && (() => {
              const rad = (bd.dir - 90) * Math.PI / 180;
              const arrowCY = TOP / 2;
              const s = 2.5 + Math.min(bd.spd / maxKnots, 1) * 4;
              const hw = 1 + Math.min(bd.spd / maxKnots, 1) * 1.2;
              const pr = rad + Math.PI / 2;
              const tipX = cx + Math.cos(rad)*s, tipY = arrowCY + Math.sin(rad)*s;
              const bX = cx - Math.cos(rad)*s, bY = arrowCY - Math.sin(rad)*s;
              return <g opacity={nowBarIdx!=null?Math.min(0.95,0.4+nearNowBoost):0.6}>
                <polygon points={`${tipX},${tipY} ${bX+Math.cos(pr)*hw},${bY+Math.sin(pr)*hw} ${bX-Math.cos(pr)*hw},${bY-Math.sin(pr)*hw}`} fill={col}/>
              </g>;
            })()}
            {isHourStart && <text x={h===startHour ? bx+1 : cx} y={H-3} fill={isNearNow&&dist<=2?"#7ac8d8":"#3a5565"} fontSize="8" textAnchor={h===startHour ? "start" : "middle"} fontFamily="'Josefin Sans', sans-serif">{h>12?`${h-12}pm`:h===12?"12pm":`${h}am`}</text>}
          </g>
        );
      })}
      {(bestTimes||[]).length >= 2 && (() => {
        const s = [...bestTimes].sort((a,b)=>a.hour-b.hour);
        const bx1 = WPAD+(s[0].hour-startHour)*4*step, bx2 = WPAD+(s[1].hour-startHour+1)*4*step;
        return <g>
          <rect x={bx1} y={TOP} width={bx2-bx1} height={H-TOP-BOT} fill="#2ecc71" opacity="0.08"/>
          <line x1={bx1} y1={TOP} x2={bx1} y2={H-BOT} stroke="#2ecc71" strokeWidth="1" strokeDasharray="3,2" opacity="0.4"/>
          <line x1={bx2} y1={TOP} x2={bx2} y2={H-BOT} stroke="#2ecc71" strokeWidth="1" strokeDasharray="3,2" opacity="0.4"/>
        </g>;
      })()}
      {nx != null && <line x1={nx} y1={TOP} x2={nx} y2={H-BOT} stroke="#2ab4d4" strokeWidth="1" strokeDasharray="3,2" opacity="0.6"/>}
      <text x={WPAD+2} y={TOP+6} fill="#3a5565" fontSize="7" fontFamily="'Josefin Sans', sans-serif">20kts</text>
    </svg>
  );
}

// ─── Main Widget ─────────────────────────────────────────────────────
export default function SwellWidget() {
  const [dayData, setDayData] = useState(null);
  const [tidesExact, setTidesExact] = useState([]);
  const [buoy, setBuoy] = useState(null);
  const [dateStr, setDateStr] = useState("");
  const [loading, setLoading] = useState(true);
  const [wavePhase, setWavePhase] = useState(0);

  useEffect(() => {
    let raf;
    const tick = () => { setWavePhase(p => p + 0.025); raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    const ds = localDateStr(new Date());
    setDateStr(ds);
    Promise.all([fetchMarine(ds), fetchWeather(ds), fetchTides(ds)])
      .then(([marine, weather, tides]) => {
        setDayData(assembleHourlyData(marine, weather, tides));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    fetchTidesExact(ds).then(setTidesExact).catch(() => {});
    fetchBuoy().then(setBuoy).catch(() => {});
  }, []);

  const nowH = new Date().getHours();

  const { scores, peak, bestTimes } = useMemo(() => {
    if (!dayData) return { scores: [], peak: null, bestTimes: [] };
    const hr = dayData[nowH];
    const scored = SPOTS.map(s => ({ ...s, score: calcScore(s, hr), heights: estimateSurfHeight(s, hr) })).sort((a, b) => b.score - a.score);
    // Find best hour/spot combo (5am-8pm)
    let peak = { score: 0, hour: nowH, spot: scored[0] };
    for (let h = 5; h <= 20; h++) {
      for (const spot of SPOTS) {
        const sc = calcScore(spot, dayData[h]);
        if (sc > peak.score) peak = { score: sc, hour: h, spot };
      }
    }
    const bestTimes = peak.score >= 1.5
      ? [{ hour: Math.max(5, peak.hour - 1) }, { hour: Math.min(20, peak.hour + 1) }]
      : [];
    return { scores: scored, peak, bestTimes };
  }, [dayData, nowH]);

  const hr = dayData?.[nowH];

  if (loading) {
    return (
      <div className="sw-widget">
        <div className="sw-logo-sm"><span className="sw-logo-swell-sm">swell</span><span className="sw-logo-sb-sm">SB</span></div>
        <div className="sw-loading">Loading forecast…</div>
      </div>
    );
  }

  if (!dayData || !hr) {
    return (
      <div className="sw-widget">
        <div className="sw-logo-sm"><span className="sw-logo-swell-sm">swell</span><span className="sw-logo-sb-sm">SB</span></div>
        <div className="sw-loading">Unable to load forecast.</div>
      </div>
    );
  }

  const isMobile = window.innerWidth <= 700;
  const top5 = scores.slice(0, isMobile ? 3 : 5);
  const dateLabel = new Date(dateStr + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  const maxScore = scores.length > 0 ? Math.max(...scores.map(x => x.score)) : 0;
  const waterTemp = buoy?.waterTemp ?? sbSeasonalWaterTemp();
  const wetsuit = wetsuitRec(waterTemp);
  const boardRecStr = boardRec(scores);

  const WidgetWrapper = "a";
  const wrapperProps = { href: "/swell/", className: "sw-widget sw-widget--link", style: { textDecoration: "none", color: "inherit" } };

  return (
    <>
    <WidgetWrapper {...wrapperProps}>
      {/* Full-width banner: logo + swell + wind + buoy | right: recs + prime time */}
      <div className="sw-combined-banner" style={{ position: "relative", overflow: "hidden" }}>
        {/* Banner sine wave background */}
        <svg style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none" }}
             viewBox="0 0 600 44" preserveAspectRatio="none">
          <defs>
            <filter id="sw-glow"><feGaussianBlur stdDeviation="2" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
            <linearGradient id="sw-sineFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2aa4c4" stopOpacity="0.4"/><stop offset="100%" stopColor="#2aa4c4" stopOpacity="0"/></linearGradient>
          </defs>
          {(() => {
            const baseAmp = Math.min((hr.swellHt || 0) * 4, 20);
            const cyc = hr.swellPer >= 14 ? 2.5 : hr.swellPer >= 10 ? 3.5 : 5;
            const pth = sineWavePath(600, 44, baseAmp > 0 ? baseAmp : 2, -wavePhase * 0.7, cyc, 22);
            const op = hr.swellHt > 0.5 ? 0.35 : 0.12;
            return <><path d={pth + ' L600,44 L0,44 Z'} fill="url(#sw-sineFill)" stroke="none" opacity={op}/><path d={pth} fill="none" stroke="#2aa4c4" strokeWidth="1.2" opacity={op} filter="url(#sw-glow)"/></>;
          })()}
        </svg>
        {/* Left group */}
        <div className="sw-banner-left">
          <div className="sw-logo-sm">
            <span className="sw-logo-swell-sm">swell</span><span className="sw-logo-sb-sm">SB</span>
          </div>
          <div className="sw-banner-div-sm" />
          <Compass dir={hr.swellDir} size={26} color="#c9a84c" value={hr.swellHt} maxValue={10} />
          <div className="sw-banner-vals">
            <span className="sw-banner-big">{hr.swellHt.toFixed(1)}<span className="sw-banner-unit">ft</span></span>
            <span className="sw-banner-sub">{hr.swellPer.toFixed(0)}s · {degToCompass(hr.swellDir)}</span>
          </div>
          <div className="sw-banner-div-sm" />
          <Compass dir={hr.windDir} size={26} color={windSpeedColor(hr.windSpeed)} value={hr.windSpeed} maxValue={25} />
          <div className="sw-banner-vals">
            <span className="sw-banner-big" style={{ color: windSpeedColor(hr.windSpeed) }}>{Math.round(hr.windSpeed)}<span className="sw-banner-unit">kts</span></span>
            <span className="sw-banner-sub">{degToCompass(hr.windDir)}{hr.windGust > hr.windSpeed + 3 ? ` G${Math.round(hr.windGust)}` : ""}</span>
          </div>
        </div>
        {/* Right group — always pinned right */}
        <div className="sw-banner-right">
          {/* Best spot + time + recs */}
          <div className="sw-banner-prime">
            {peak && peak.score > 0 ? (
              <>
                <span style={{ color: "#f0ede8", fontFamily: "'Josefin Sans', sans-serif", fontSize: "0.58rem", fontWeight: 600, textAlign: "center" }}>
                  {peak.spot?.name === "Campus Point" ? "Campus Pt" : peak.spot?.name} · {fmtHr(peak.hour)}
                </span>
                <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 2 }}>
                  {wetsuit && <span style={{ fontSize: "0.52rem", color: "#7ac8d8", fontFamily: "'Josefin Sans', sans-serif" }}>{wetsuit}</span>}
                  {boardRecStr && <span style={{ fontSize: "0.52rem", color: "#c9a84c", fontFamily: "'Josefin Sans', sans-serif" }}>{boardRecStr}</span>}
                </div>
              </>
            ) : (
              <span style={{ color: "#f0ede8", fontFamily: "'Josefin Sans', sans-serif", fontSize: "0.58rem", fontWeight: 600 }}>No Surf</span>
            )}
          </div>
          <div className="sw-banner-div-sm" />
          {/* Date + stars + rating */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, flexShrink: 0 }}>
            <span className="sw-date">{dateLabel}</span>
            <StarRating score={peak?.score || 0} size={12} />
            <span style={{ color: starColor(peak?.score || 0), fontFamily: "'Josefin Sans', sans-serif", fontSize: "0.6rem", fontWeight: 700 }}>
              {peak && peak.score > 0 ? scoreLabel(peak.score) : "Flat"}
            </span>
          </div>
        </div>
      </div>

      {/* Two-column body: spots left, charts right */}
      <div className="sw-body">
        {/* Left column — Spot Ratings */}
        <div className="sw-spots">
          <div className="sw-section-label">Spot Ratings</div>
          {top5.map((s, idx) => {
            const [lo, hi] = s.heights;
            const faceRange = (s.score === 0 || hi < 1) ? "0ft" : `${lo}-${hi}ft`;
            const isBest = idx === 0 && s.score > 0;
            const a = maxScore > 0 && s.score > 0 ? Math.min(0.22, (s.score / maxScore) * 0.22) : 0;
            const bg = a > 0
              ? `linear-gradient(150deg, rgba(10,15,20,0.95) 0%, #2aa4c4${Math.round(a*255).toString(16).padStart(2,'0')} 100%)`
              : "rgba(10,15,20,0.95)";
            const border = isBest ? "#2aa4c499" : s.score > 0 ? "#2aa4c422" : "#0d1623";
            const sineAmp = Math.min(hi * 1.0, 6);
            const sOp = s.score > 0 ? (isBest ? 0.55 : 0.08 + (maxScore > 0 ? (s.score / maxScore) * 0.22 : 0)) : 0;
            const per = hr?.swellPer || 10;
            const sCycles = per >= 14 ? 6.0 : per >= 11 ? 7.5 : per >= 9 ? 9.0 : 11.0;
            const sSpeed = 0.5 + (idx % 5) * 0.15;
            const sPth = sineWavePath(300, 48, sineAmp, idx * 1.1 - wavePhase * sSpeed, sCycles, 42);
            const swellQ = swellQuality(hr.swellDir || 0, s);
            const tideQ = tideFavorable(s, hr.tideH ?? 2.5, hr.tideRate ?? 0);
            const windQ = windQualityStr(hr.windSpeed || 0, hr.windDir || 0, s);
            const optMid = Math.round(((s.swOpt[0] + s.swOpt[1]) / 2) % 360);
            const spotTransfer = (hr.swellHt * channelTransfer(hr.swellDir || 0, hr.swellPer || 10, s)).toFixed(1);
            return (
              <div key={s.name} className="sw-spot-card" style={{
                position: "relative", overflow: "hidden",
                padding: "4px 8px", borderBottom: `1px solid ${border}`,
              }}>
                <svg style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none" }}
                     viewBox="0 0 300 48" preserveAspectRatio="none">
                  <defs><filter id={`sg${idx}`}><feGaussianBlur stdDeviation={isBest ? 3 : Math.max(0.5, (maxScore > 0 ? (s.score / maxScore) * 2.5 : 0.5))} result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter><linearGradient id={`sf${idx}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2aa4c4" stopOpacity="0.6"/><stop offset="100%" stopColor="#2aa4c4" stopOpacity="0"/></linearGradient></defs>
                  <path d={sPth + ' L300,48 L0,48 Z'} fill={`url(#sf${idx})`} stroke="none" opacity={sOp}/>
                  <path d={sPth} fill="none" stroke="#2aa4c4" strokeWidth="1.2" opacity={sOp} filter={`url(#sg${idx})`}/>
                </svg>
                <div style={{ display: "flex", alignItems: "center", gap: 6, position: "relative", zIndex: 1 }}>
                  {/* Left: name + tags */}
                  <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
                    <div style={{ marginBottom: 2, display: "flex", alignItems: "baseline", overflow: "hidden" }}>
                      <span className="sw-spot-name" style={{ fontSize: 13, fontWeight: 400, color: isBest ? "#f0ede8" : "#c8d8e0", fontFamily: "'Josefin Sans', sans-serif" }}>{s.name}</span>
                      <span className="sw-spot-transfer" style={{ fontSize: 9, color: "#6aaaba", fontFamily: "'Josefin Sans', sans-serif", marginLeft: 6 }}>{spotTransfer}ft {degToCompass(hr.swellDir)} @{Math.round(per)}s</span>
                    </div>
                    <div className="sw-spot-tags">
                      {[
                        { color: tagColor(swellQ), text: `${degToCompass(optMid)} swell` },
                        { color: tagColor(tideQ), text: `${s.tide} tide` },
                        { color: tagColor(windQ), text: "wind" },
                      ].map((tag, ti) => (
                        <span className="sw-spot-tag" key={ti} style={{ fontSize: 8, padding: "2px 4px", borderRadius: 3, background: "#0d1420", color: tag.color, fontFamily: "'Josefin Sans', sans-serif", fontWeight: 600, letterSpacing: "0.06em", border: `1px solid ${tag.color}35`, whiteSpace: "nowrap" }}>{tag.text}</span>
                      ))}
                    </div>
                  </div>
                  {/* Center: face height + wind */}
                  <div style={{ flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, minWidth: 42 }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "#7ac8d8", fontFamily: "'Josefin Sans', sans-serif", lineHeight: 1 }}>{faceRange}</span>
                    <span style={{ fontSize: 8, color: windSpeedColor(hr.windSpeed), fontFamily: "'Josefin Sans', sans-serif", whiteSpace: "nowrap" }}>{Math.round(hr.windSpeed)}kts {degToCompass(hr.windDir)}</span>
                  </div>
                  {/* Right: stars + label */}
                  <div className="sw-spot-info" style={{ flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minWidth: 44 }}>
                    <StarRating score={s.score} size={11} />
                    <div style={{ fontSize: 8, color: starColor(s.score), marginTop: 1, fontFamily: "'Josefin Sans', sans-serif", fontWeight: 600 }}>{scoreLabel(s.score)}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Right column — Charts */}
        <div className="sw-charts">
          <div className="sw-chart-row">
            <div className="sw-chart-label">Today's Tide<span className="sw-chart-label-unit">ft</span></div>
            <TideChart data={dayData} nowHour={nowH} bestTimes={bestTimes} dateStr={dateStr} tidesExact={tidesExact} />
          </div>
          <div className="sw-chart-row">
            <div className="sw-chart-label">Today's Surf Height<span className="sw-chart-label-unit">ft</span></div>
            <SwellChart data={dayData} nowHour={nowH} bestTimes={bestTimes} />
          </div>
          <div className="sw-chart-row">
            <div className="sw-chart-label">Today's Wind<span className="sw-chart-label-unit">kts</span></div>
            <WindChart data={dayData} nowHour={nowH} bestTimes={bestTimes} />
          </div>
        </div>
      </div>
    </WidgetWrapper>

    {/* CTA — centered below widget, hidden on mobile */}
    {!isMobile && (
      <div className="sw-cta-wrap">
        <a href="/swell/" className="sw-cta">
          See Full Forecast
        </a>
      </div>
    )}
    </>
  );
}
